'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _apiHelper = require('api/api-helper');

var _selectors = require('selectors');

var _departureServicesDataActions = require('actions/departureServicesDataActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchDepartureServicesData);

function fetchDepartureServicesData() {
    var authToken, locale, depServiceIds, depServicesById, newDepServiceIds, newDepServicesData, errorMessage, i, error;
    return _regenerator2.default.wrap(function fetchDepartureServicesData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.take)(_departureServicesDataActions.DEPARTURE_SERVICES_DATA_REQUESTED);

                case 2:
                    _context.next = 4;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 4:
                    authToken = _context.sent;
                    _context.next = 7;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 7:
                    locale = _context.sent;
                    _context.next = 10;
                    return (0, _effects.select)(_selectors.getDepartureServiceIds);

                case 10:
                    depServiceIds = _context.sent;
                    _context.next = 13;
                    return (0, _effects.select)(_selectors.getDepartureServicesById);

                case 13:
                    depServicesById = _context.sent;


                    // ids of departure services we need to fetch
                    // (because they did not have all the data we required (see selectors.js))
                    newDepServiceIds = depServiceIds.filter(function (depServiceId) {
                        return !depServicesById[depServiceId];
                    });
                    _context.next = 17;
                    return newDepServiceIds.map(function (depServiceId) {
                        return (0, _effects.call)(_apiHelper.getResourceData, depServiceId, 'departure_services', authToken, locale);
                    });

                case 17:
                    newDepServicesData = _context.sent;
                    errorMessage = void 0;
                    i = 0;

                case 20:
                    if (!(i < newDepServicesData.length)) {
                        _context.next = 28;
                        break;
                    }

                    error = newDepServicesData[i].error;

                    if (!error) {
                        _context.next = 25;
                        break;
                    }

                    // Call to API for depServicesData fails
                    errorMessage = error._error;
                    return _context.abrupt('break', 28);

                case 25:
                    i++;
                    _context.next = 20;
                    break;

                case 28:
                    if (!errorMessage) {
                        _context.next = 33;
                        break;
                    }

                    _context.next = 31;
                    return (0, _effects.put)((0, _departureServicesDataActions.departureServicesDataRequestFailed)(errorMessage));

                case 31:
                    _context.next = 35;
                    break;

                case 33:
                    _context.next = 35;
                    return (0, _effects.put)((0, _departureServicesDataActions.departureServicesDataReceived)(newDepServicesData.map(function (x) {
                        return x.resourceData;
                    })));

                case 35:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchDepartureServicesData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchDepartureServicesData.js
// module id = 1412
// module chunks = 0